import {computeColorCode} from "@/pages/mindmap/CarNodes/nodeUtils.ts";

export const COLOR_MAP: Record<string, Record<string, any>> = {
    '3': {color: '#dc2626', fontWeight: 700},
    '2': {color: '#059669', fontWeight: 700},
    '1': {color: '#1e293b', fontWeight: 700},
}